<script setup lang="ts">
defineProps<{
	errors?: { msg: string; path?: string }[]
}>()
</script>

<template>
	<section v-if="errors && errors.length" class="g-form-errors l-stack">
		<h2>Whoa, hold up there!</h2>

		<p>There are some validation errors in what you provided. Could you please double-check these fields:</p>

		<ul>
			<li v-for="(error, i) in errors" :key="i">
				<strong v-if="error.path">{{ error.path }}</strong>
				{{ error.msg }}
			</li>
		</ul>
	</section>
</template>
